"use strict"
var __assign = (this && this.__assign) || function () {
  __assign = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i]
      for (var p in s) {if (Object.prototype.hasOwnProperty.call(s, p))
      {t[p] = s[p]}}
    }
    return t
  }
  return __assign.apply(this, arguments)
}
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value) }) }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) { try { step(generator.next(value)) } catch (e) { reject(e) } }
    function rejected(value) { try { step(generator["throw"](value)) } catch (e) { reject(e) } }
    function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected) }
    step((generator = generator.apply(thisArg, _arguments || [])).next())
  })
}
var __generator = (this && this.__generator) || function (thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1] }, trys: [], ops: [] }, f, y, t, g
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this }), g
  function verb(n) { return function (v) { return step([n, v]) } }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.")
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t
        if (y = 0, t) op = [op[0] & 2, t.value]
        switch (op[0]) {
        case 0: case 1: t = op; break
        case 4: _.label++; return { value: op[1], done: false }
        case 5: _.label++; y = op[1]; op = [0]; continue
        case 7: op = _.ops.pop(); _.trys.pop(); continue
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue }
          if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break }
          if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break }
          if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break }
          if (t[2]) _.ops.pop()
          _.trys.pop(); continue
        }
        op = body.call(thisArg, _)
      } catch (e) { op = [6, e]; y = 0 } finally { f = t = 0 }}
    if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true }
  }
}
// constants
var hourHeight = 400
var offset = 50
var roughBufferingHours = 12 // Amount of hours we buffer from selection
var roughBufferingHoursThreshold = 6 // Amount of hours you need to cross before last buffered date so we start rough buffering
var detailedBufferingHours = 1.0 / 60 // 1 minute of detailed buffering
var detailedBufferingHoursThreshold = 0.5 / 60
var detailedPoseCutoffSeconds = 15
var roughPoseCutoffSeconds = 120
var PersonPositionType;
(function (PersonPositionType) {
  PersonPositionType[PersonPositionType["Standing"] = 0] = "Standing"
  PersonPositionType[PersonPositionType["Sitting"] = 1] = "Sitting"
  PersonPositionType[PersonPositionType["SittingOnBed"] = 2] = "SittingOnBed"
  PersonPositionType[PersonPositionType["LyingOnBed"] = 3] = "LyingOnBed"
  // LyingUnderCovers = 4,
  PersonPositionType[PersonPositionType["LyingOnFloor"] = 5] = "LyingOnFloor"
  PersonPositionType[PersonPositionType["LyingOther"] = 6] = "LyingOther"
  PersonPositionType[PersonPositionType["SittingOnFloor"] = 8] = "SittingOnFloor"
  PersonPositionType[PersonPositionType["InvalidHuman"] = -1] = "InvalidHuman"
})(PersonPositionType || (PersonPositionType = {}))
function addMilliseconds(d, n) {
  var newD = new Date(d)
  newD.setTime(newD.getTime() + n)
  return newD
}
function addHours(d, n) {
  return addMilliseconds(d, n * 60 * 60 * 1000)
}
function overlap(range1, range2) {
  // Make sure latest timestamp is in front
  if (range1[0] < range1[1]) {
    return overlap([range1[1], range1[0]], range2)
  }
  if (range2[0] < range2[1]) {
    return overlap(range1, [range2[1], range2[0]])
  }
  return ((range1[0] >= range2[0] && range2[0] >= range1[1]) || // latest of range two is inside range1
        (range1[0] >= range2[1] && range2[1] >= range1[1]) || // earliest of range two is inside range 1
        (range1[0] >= range2[0] && range2[1] >= range1[1]) || // range 2 is inside range 1
        (range2[0] >= range1[0] && range1[1] >= range2[1]) // range 1 is inside range 2
  )
}
// returns a single date OLDER than the second date ("past")
//   if buffering is needed as the rough buffer is continuous
// Newer Rough buffer is handled somewhere else
function needsRoughBufferingHistory(state) {
  if (state.roughPoseBufferRequestOpen !== null) {
    // If request is already in transit -> wait for that one
    return { tag: "AlreadyBuffering" }
  }
  var threshholdPast = addHours(state.roughPoseBuffer.range[1], roughBufferingHoursThreshold)
  if (state.selectedTimeAdjusted < threshholdPast) {
    return {
      tag: "NeedsBuffering",
      data: addHours(state.selectedTimeAdjusted, -roughBufferingHours)
    }
  }
  else {
    return { tag: "DoesntNeedBuffering" }
  }
}
function bufferRoughHistory(currentRange, toBuffer, dispatch) {
  callEndpoint({
    begin: toBuffer,
    end: currentRange[0],
    interval: 60,
    cb: function (_a) {
      var images = _a.images, poses = _a.poses, activities = _a.activities
      dispatch({
        tag: "RoughHistoryLoaded",
        toBuffer: toBuffer,
        images: images,
        poses: poses,
        activities: activities,
        currentTime: new Date()
      })
    },
    onError: function () {
      dispatch({
        tag: "RoughHistoryLoadingFailed",
        toBuffer: toBuffer
      })
    }
  })
}
function bufferNewRough(req, begin, dispatch) {
  callEndpoint({
    begin: begin,
    end: req,
    interval: 60,
    cb: function (_a) {
      var images = _a.images, poses = _a.poses, activities = _a.activities
      dispatch({
        tag: "NewRoughLoaded",
        newEnd: req,
        images: images,
        poses: poses,
        activities: activities
      })
    },
    onError: function () { }
  })
}
function bufferDetailedRange(range, dispatch) {
  var responseRequested = new Date()
  callEndpoint({
    begin: range[1],
    end: range[0],
    interval: null,
    cb: function (_a) {
      var images = _a.images, poses = _a.poses
      // console.log(`Range: ${range[0]} - ${range[1]}`);
      // console.log(`Response poses.length: ${poses.length}`);
      dispatch({
        tag: "DetailedRangeLoaded",
        range: range,
        images: images,
        poses: poses,
        responseRequested: responseRequested
      })
    },
    onError: function () {
      dispatch({
        tag: "DetailedRangeLoadingFailed",
        range: range
      })
    }
  })
}
function needsDetailedBuffering(state) {
  var containingRange = state.detailedPoseBuffers.find(function (b) {
    return b.range[0] >= state.selectedTimeAdjusted &&
            state.selectedTimeAdjusted >= b.range[1]
  })
  if (containingRange) {
    // in containing range -> check if thresholds are crossed
    var threshholdAbove = addHours(state.selectedTimeAdjusted, detailedBufferingHoursThreshold)
    var threshholdBelow = addHours(state.selectedTimeAdjusted, -detailedBufferingHoursThreshold)
    if (containingRange.range[0] < threshholdAbove) {
      return {
        tag: "NeedsBuffering",
        data: [
          addHours(state.selectedTimeAdjusted, detailedBufferingHours),
          containingRange.range[0],
        ]
      }
    }
    if (threshholdBelow < containingRange.range[1]) {
      return {
        tag: "NeedsBuffering",
        data: [
          containingRange.range[1],
          addHours(state.selectedTimeAdjusted, -detailedBufferingHours),
        ]
      }
    }
    else {
      // not crossed -> no need to buffer
      return { tag: "DoesntNeedBuffering" }
    }
  }
  else {
    // no already buffered range found -> check if request is already open
    // note: we don't take threshold into account here, could be a future optim
    var containingRangeRequestOpen = state.detailedPoseBufferRequestsOpen.find(function (b) {
      return b[0] >= state.selectedTimeAdjusted && state.selectedTimeAdjusted >= b[1]
    })
    if (containingRangeRequestOpen) {
      return { tag: "AlreadyBuffering" }
    }
    // nothing found -> new range
    var neededRange_1 = [
      addHours(state.selectedTimeAdjusted, detailedBufferingHours),
      addHours(state.selectedTimeAdjusted, -detailedBufferingHours),
    ]
    // maybe partially overlapping range
    var overlappingRange = state.detailedPoseBuffers.find(function (b) {
      return overlap(b.range, neededRange_1)
    })
    if (overlappingRange && overlappingRange.poses[0]) {
      // partially overlapping -> get only parts we don't have yet
      if (neededRange_1[0] >= overlappingRange.range[0]) {
        return {
          tag: "NeedsBuffering",
          data: [
            neededRange_1[0],
            addMilliseconds(overlappingRange.poses[0][0], 500),
          ]
        }
      }
      else {
        return {
          tag: "NeedsBuffering",
          data: [overlappingRange.range[1], neededRange_1[1]]
        }
      }
    }
    else {
      // no partially overlapping range -> get all
      return {
        tag: "NeedsBuffering",
        data: neededRange_1
      }
    }
  }
}
function getServerParams() {
  var deviceId = document.getElementById("timeline-target").dataset.deviceId
  return { baseurl: "", secret: window.settings.token, deviceId: deviceId }
}
function getUserLocaleAndTimeZone() {
  return {
    locale: document.querySelector("meta[name=locale]").content,
    timeZone: document.querySelector("meta[name=time_zone]").content
  }
}

function callEndpoint(_a) {
  var begin = _a.begin, end = _a.end, interval = _a.interval, cb = _a.cb, onError = _a.onError
  var _b = getServerParams(), baseurl = _b.baseurl, secret = _b.secret, deviceId = _b.deviceId
  $.ajax(baseurl + "/person_poses/timeline", {
    data: {
      authenticity_token: secret,
      begin: begin.toISOString(),
      end: end.toISOString(),
      interval: interval,
      device_id: deviceId
    },
    dataType: "json",
    timeout: 15000,
    success: function (data) {
      // TODO Timezones!!! I send UTC and get UTC I think, but I have a feeling something might be wrong here
      var poses = data.timeline
        .map(function (i) {
          return [new Date(i.taken_on), [i]]
        })
        .sort(function (a, b) {
          return a[0] > b[0] ? -1 : 1 // sorting by Date desc
        })
      var images = data.images
        .map(function (i) {
          return [new Date(i.taken_on), i]
        })
        .sort(function (a, b) {
          return a[0] > b[0] ? -1 : 1 // sorting by Date desc
        })
      var activities = data.activities
        .map(function (a) { return ({
          time: new Date(a.time),
          desc: a.desc,
          icon: a.icon,
          is_in_bed: a.is_in_bed
        }) })
        .sort(function (a, b) {
          return a.time > b.time ? -1 : 1 // sorting by time desc
        })
      // console.log(`Range: ${end} - ${begin}`);
      // console.log(`Interval: ${interval}`);
      // console.log(`Response poses.length: ${poses.length}`);
      cb({ poses: poses, images: images, activities: activities })
    },
    error: function (_, statusText) {
      console.error(statusText)
      onError()
    }
  })
}
function getSourceImage(poseId) {
  return __awaiter(this, void 0, void 0, function () {
    var _a, baseurl, secret, deviceId, data
    return __generator(this, function (_b) {
      _a = getServerParams(), baseurl = _a.baseurl, secret = _a.secret, deviceId = _a.deviceId
      data = {
        secret: secret,
        device_id: deviceId
      }
      return [2 /*return*/, $.ajax({
        url: baseurl + ("/admin/person_poses/" + poseId + "/source"),
        type: "GET",
        data: data
      }).then(function (res) {
        return res.image
      })]
    })
  })
}
var allPositions = [
  [PersonPositionType.Standing, "Standing"],
  [PersonPositionType.Sitting, "Sitting"],
  [PersonPositionType.SittingOnBed, "Sitting on bed"],
  [PersonPositionType.LyingOnBed, "Lying on bed"],
  // [PersonPositionType.LyingUnderCovers, "Lying under covers"],
  [PersonPositionType.LyingOnFloor, "Lying on floor"],
  [PersonPositionType.SittingOnFloor, "Sitting on floor"],
  [PersonPositionType.LyingOther, "Lying other"],
  [PersonPositionType.InvalidHuman, "Invalid human"],
]
function initDomElements(parent, document, enableTimeline, ratio) {
  // Rendering fixed elements
  parent.setAttribute("style", "")
  if (window.admin === true || window.admin === "true") {
    parent.setAttribute("class", "admin")
  }
  var mainContainer = document.createElement("div")
  mainContainer.setAttribute("class", "timelinemain")
  parent.appendChild(mainContainer)
  var videoContainer = document.createElement("div")
  videoContainer.setAttribute("class", "video-container")
  mainContainer.appendChild(videoContainer)
  var video = document.createElement("div")
  var videoPlayerHeight = (ratio.y / ratio.x) * mainContainer.getBoundingClientRect().width // Keeping aspect of pictures
  if (ratio.x == 1 && ratio.y == 1){ //TODO: Refactor hack (PR: #933)
    video.setAttribute("class", "video-fisheye")
  } else {
    video.setAttribute("class", "video")
  }
  videoContainer.appendChild(video)
  if (ratio.x == 1 && ratio.y == 1){ //TODO: Refactor hack (PR: #933)
    videoContainer.setAttribute("style", "height: " + videoPlayerHeight + "px; max-width: " + videoPlayerHeight + "px")
  } else {
    videoContainer.setAttribute("style", "height: " + videoPlayerHeight + "px")
  }
  var canvas = document.createElement("canvas")
  // VideoContainer gets dynamically sized as 16:9, with 16 = device width
  var videoContainerDims = videoContainer.getBoundingClientRect()
  var timelineContainer = document.createElement("div")
  timelineContainer.setAttribute("class", "timeline-container")
  if (enableTimeline === false || enableTimeline === "false") {
    timelineContainer.classList.add("tw-hidden")
  }
  timelineContainer.setAttribute("style", "height: " +
        (window.innerHeight - videoContainerDims.y - videoPlayerHeight) +
        "px")
  mainContainer.appendChild(timelineContainer)
  timelineContainer.scrollTo({ top: 0 })
  // Positioning this line just 50px under it, with position: FIXED -> need dims
  var fixedLine = document.createElement("div")
  fixedLine.setAttribute("style", "top: " + (videoContainerDims.y + videoContainerDims.height + offset) + "px; width: " + (videoContainerDims.width) + "px;")
  fixedLine.setAttribute("class", "fixedline")
  timelineContainer.appendChild(fixedLine)
  var fixedLineText = document.createElement("label")
  fixedLine.appendChild(fixedLineText)
  // Positioning this just under video, taking up rest of the screen -> need dims
  var timeline = document.createElement("div")
  timeline.setAttribute("class", "timeline")
  timelineContainer.appendChild(timeline)
  var ui = null
  if (window.admin === true || window.admin === "true") {
    var realviewContainer = document.createElement("div")
    realviewContainer.setAttribute("class", "realview")
    var relviewImage = document.createElement("img")
    relviewImage.setAttribute("style", "height: " + videoPlayerHeight + "px; width: " + (videoPlayerHeight * ratio.x) / ratio.y + "px; margin: 0 auto; display: block;")
    var relviewImageContainer = document.createElement("div")
    relviewImageContainer.setAttribute("style", "height: " + videoPlayerHeight + "px; width: 100%; background-color: #337079; border-bottom: 2px solid black;")
    relviewImageContainer.appendChild(relviewImage)
    var realviewSubcontainer1 = document.createElement("div")
    realviewSubcontainer1.setAttribute("class", "tw-flex")
    var showSourceButton = document.createElement("button")
    showSourceButton.innerText = "Show source"
    addClass(showSourceButton, "show-only-when-paused")
    var pauseButton = document.createElement("button")
    pauseButton.innerText = "Pause"
    pauseButton.id = "pause"
    var prevButton = document.createElement("button")
    prevButton.innerText = "Prev"
    addClass(prevButton, "show-only-when-paused")
    var nextButton = document.createElement("button")
    nextButton.innerText = "Next"
    addClass(nextButton, "show-only-when-paused")
    realviewSubcontainer1.appendChild(pauseButton)
    realviewSubcontainer1.appendChild(showSourceButton)
    realviewSubcontainer1.appendChild(prevButton)
    realviewSubcontainer1.appendChild(nextButton)
    var realviewSubcontainer2 = document.createElement("div")
    realviewSubcontainer2.setAttribute("class", "tw-flex")
    var showUpTillNowButton = document.createElement("button")
    showUpTillNowButton.innerText = "Show up till now"
    addClass(showUpTillNowButton, "show-only-when-paused")
    var showFromNowOnButton = document.createElement("button")
    showFromNowOnButton.innerText = "Show from now on"
    addClass(showFromNowOnButton, "show-only-when-paused")
    realviewSubcontainer2.appendChild(showUpTillNowButton)
    realviewSubcontainer2.appendChild(showFromNowOnButton)
    realviewContainer.appendChild(relviewImageContainer)
    realviewContainer.appendChild(realviewSubcontainer1)
    realviewContainer.appendChild(realviewSubcontainer2)
    var poseIndicator = document.createElement("div")
    addClass(poseIndicator, "pose-indicator")
    videoContainer.appendChild(poseIndicator)
    parent.appendChild(realviewContainer)
    var realview = {
      showSourceButton: showSourceButton,
      pauseButton: pauseButton,
      prevButton: prevButton,
      nextButton: nextButton,
      showUpTillNowButton: showUpTillNowButton,
      showFromNowOnButton: showFromNowOnButton,
      realviewContainer: realviewContainer,
      video: relviewImage
    }
    ui = {
      realview: realview,
      poseIndicator: poseIndicator
    }
  }
  // Canvas needs to overlap picture exactly
  canvas.setAttribute("width", videoContainerDims.width + "px")
  canvas.setAttribute("height", videoContainerDims.height + "px")
  canvas.setAttribute("class", "pose-canvas")
  mainContainer.appendChild(canvas)
  var ctx = canvas.getContext("2d")
  if (ctx === null) {
    throw new Error("Canvas not supported")
  }
  return { timelineContainer: timelineContainer, timeline: timeline, fixedLineText: fixedLineText, video: video, ctx: ctx, canvas: canvas, ui: ui }
}
function zip(first, second) {
  var res = []
  var j = Math.min(first.length, second.length)
  for (var i = 0; i < j; i++) {
    res.push([first[i], second[i]])
  }
  return res
}
function renderPose(_a, ratio) {
  var ctx = _a.ctx, canvasWidth = _a.canvasWidth, canvasHeight = _a.canvasHeight, coords = _a.coords

  const imageResolution = ratio.x == 1 && ratio.y == 1 ? [1712 * 2, 1712 * 2] : [2560, 1440]
  var xScale = imageResolution[0] / 2 / canvasWidth
  var yScale = imageResolution[1] / 2 / canvasHeight

  var connections = [
    [1, 2],
    [1, 5],
    [2, 3],
    [3, 4],
    [5, 6],
    [6, 7],
    [1, 8],
    [8, 9],
    [9, 10],
    [1, 11],
    [11, 12],
    [12, 13],
    [1, 0],
    [0, 14],
    [14, 16],
    [0, 15],
    [15, 17],
  ]
  var posecolors = [
    "rgb(255,0,85)",
    "rgb(255,0,0)",
    "rgb(255,85,0)",
    "rgb(255,170,0)",
    "rgb(255,255,0)",
    "rgb(170,255,0)",
    "rgb(85,255,0)",
    "rgb(0,255,0)",
    "rgb(0,255,85)",
    "rgb(0,255,170)",
    "rgb(0,255,255)",
    "rgb(0,170,255)",
    "rgb(0,85,255)",
    "rgb(0,0,255)",
    "rgb(255,0,170)",
    "rgb(170,0,255)",
    "rgb(255,0,255)",
    "rgb(85,0,255)",
  ]
  ctx.lineWidth = 2
  coords.forEach(function (_a) {
    var x = _a[0], y = _a[1]
    ctx.fillStyle = "#005500"
    ctx.beginPath()
    ctx.arc(x / xScale, y / yScale, 1, 0, 2 * Math.PI)
    ctx.stroke()
    ctx.fill()
    ctx.closePath()
  })
  connections.forEach(function (item, index) {
    ctx.beginPath()
    ctx.strokeStyle = posecolors[index]
    var startCoords = coords[item[0]]
    var endCoords = coords[item[1]]
    ctx.moveTo(startCoords[0] / xScale, startCoords[1] / yScale)
    ctx.lineTo(endCoords[0] / xScale, endCoords[1] / yScale)
    ctx.stroke()
    ctx.closePath()
  })
}
var cameraToTopLeft = {
  0: { top: 0, left: 0 },
  1: { top: 0, left: 1 },
  2: { top: 1, left: 0 },
  3: { top: 1, left: 1 }
}
function rangeContains(range, d) {
  return range[0] >= d && range[1] <= d
}
function timeDiffInMs(t1, t2) {
  return t1 < t2 ? timeDiffInMs(t2, t1) : t1.getTime() - t2.getTime()
}

function findBestPose(state) {
  var time = state.selectedTimeAdjusted
  var bestFromDetailedBuffers = state.detailedPoseBuffers.reduce(function (acc, b) {
    // For perf, we first check to make sure the best possible pose (= the latest one) from this buffer is better than the current best
    var latestPose = b.poses[0] || null
    if (latestPose === null) {
      return acc
    }
    if (acc !== null && acc[0] < latestPose[0]) {
      return acc
    }
    // We check if we have a pose that is earlier than time and is better than the current best one
    var bestPose = b.poses.find(function (b) { return b[0] < time }) || null
    if (acc === null ||
            (acc !== null && bestPose !== null && bestPose[0] > acc[0])) {
      return bestPose
    }
    return acc
  }, null)

  var bestFromRoughBuffer = state.roughPoseBuffer.poses.find(function (i) { return i[0] < time }) || null

  var best = bestFromRoughBuffer === null
    ? bestFromDetailedBuffers === null
      ? null
      : ["detail", bestFromDetailedBuffers]
    : bestFromDetailedBuffers === null
      ? ["rough", bestFromRoughBuffer]
      : bestFromRoughBuffer[0] > bestFromDetailedBuffers[0] // find the latest = best
        ? ["rough", bestFromRoughBuffer]
        : ["detail", bestFromDetailedBuffers]
  if (best === null) {
    var loadingFound = state.detailedPoseBufferRequestsOpen.find(function (r) {
      return rangeContains(r, time)
    }) ||
            (state.roughPoseBufferRequestOpen !== null &&
                rangeContains([state.roughPoseBuffer.range[1], state.roughPoseBufferRequestOpen], time)
              ? state.roughPoseBufferRequestOpen
              : null)
    null
    var errorFound = state.detailedPoseBufferRequestsFailed.find(function (r) {
      return rangeContains(r, time)
    }) || null
    if (loadingFound !== null) {
      return { tag: "PoseLoading" }
    }
    else if (errorFound !== null) {
      return { tag: "PoseServerError" }
    }
    else {
      // We don't have any data, but also don't have an error -> just show No Data
      return { tag: "PoseNoData" }
    }
  }
  if (best[0] === "detail") {
    if (timeDiffInMs(best[1][0], time) > detailedPoseCutoffSeconds * 1000) {
      return { tag: "PoseNoData" }
    }
    else {
      return { tag: "PoseFound", data: best[1] }
    }
  }
  if (best[0] === "rough") {
    if (timeDiffInMs(best[1][0], time) > roughPoseCutoffSeconds * 1000) {
      return { tag: "PoseNoData" }
    }
    else {
      return { tag: "PoseFound", data: best[1] }
    }
  }
  expectNever(best[0])
}

function renderInBedResident(videoEl, ctx, canvasDims) {
  ctx.clearRect(0, 0, canvasDims.canvasWidth, canvasDims.canvasHeight)
  videoEl.setAttribute("style", "background-image: none")
  videoEl.setAttribute("alt", "Bed in resident")
  videoEl.setAttribute("data-timeline-no-data-found-text", window.I18n.timeline.bed_in_resident)
}

function renderNoDataFound(videoEl, ctx, canvasDims) {
  ctx.clearRect(0, 0, canvasDims.canvasWidth, canvasDims.canvasHeight)
  videoEl.setAttribute("style", "background-image: none")
  videoEl.setAttribute("alt", "No data found")
  videoEl.setAttribute("data-timeline-no-data-found-text", window.I18n.timeline.no_data_found_text)
}
function renderServerError(videoEl, ctx, canvasDims) {
  ctx.clearRect(0, 0, canvasDims.canvasWidth, canvasDims.canvasHeight)
  videoEl.setAttribute("style", "background-image: none")
  videoEl.setAttribute("alt", "Server error")
  videoEl.setAttribute("data-timeline-server-error-text", window.I18n.timeline.server_error_text)
}
function renderLoading(videoEl, ctx, canvasDims) {
  ctx.clearRect(0, 0, canvasDims.canvasWidth, canvasDims.canvasHeight)
  videoEl.setAttribute("style", "background-image: none")
  videoEl.setAttribute("alt", "Loading")
  videoEl.setAttribute("data-timeline-loading-text", window.I18n.timeline.loading_text)
}
var imageCache = {}
function loadImageIntoCache(_a) {
  var fileName = _a.fileName, url = _a.url
  imageCache[fileName] = {
    tag: "Loading",
    url: url
  }
  var img = new Image()
  img.src = url
  img.addEventListener("load", function () {
    imageCache[fileName] = {
      tag: "Loaded",
      url: url
    }
  })
  img.addEventListener("error", function () {
    delete imageCache[fileName]
  })
}
function setBackgroundImage(videoEl, url, topLeft) {
  videoEl.setAttribute("alt", "")
  videoEl.setAttribute("style", [
    "background-image: url('" + url + "')",
    "top: " + topLeft.top * -100 + "%",
    "left: " + topLeft.left * -100 + "%",
  ].join(";"))
}

function findLatestActivity(state) {
  var time = state.selectedTimeAdjusted
  var activities = state.roughPoseBuffer.activities
  return activities.find(function (activity) {
    return activity.time < time
  }) || null
}

function renderVideo(videoEl, poseIndicator, ctx, state, canvasDims, ratio) {
  var poseFound = findBestPose(state)
  switch (poseFound.tag) {
  case "PoseNoData":
    var latestActivity = findLatestActivity(state)
    if (latestActivity === null) {
      return renderNoDataFound(videoEl, ctx, canvasDims)
    } else if(latestActivity.is_in_bed) {
      return renderInBedResident(videoEl, ctx, canvasDims)
    }

    return renderNoDataFound(videoEl, ctx, canvasDims)
  case "PoseServerError":
    return renderServerError(videoEl, ctx, canvasDims)
  case "PoseLoading":
    return renderLoading(videoEl, ctx, canvasDims)
  case "PoseFound":
    var pose = poseFound.data
    var firstPose_1 = pose[1][0]
    if (!firstPose_1) {
      return renderNoDataFound(videoEl, ctx, canvasDims)
    }
    firstPose_1 = firstPose_1.poses[0]
    var topAndLeftRelative = cameraToTopLeft[firstPose_1.camera]
    if (!topAndLeftRelative) {
      return renderNoDataFound(videoEl, ctx, canvasDims)
    }
    // images and poses are sorted Data DESC, so we need to find the FIRST entry that is EARLIER than the selected time()
    var refImage = state.images.images.find(function (i) { return i[0] < state.selectedTimeAdjusted }) ||
                null
    if (refImage === null) {
      return renderNoDataFound(videoEl, ctx, canvasDims)
    }
    // TODO: I think this can cause race conditions, showing wrong images if one loads before the other. Not sure
    var parsedImgUrl = new URLSearchParams(refImage[1].url)
    var fileName = parsedImgUrl.get("response-content-disposition") || null
    if (fileName !== null) {
      var alreadyLoadedUrl = imageCache[fileName] || null
      if (alreadyLoadedUrl !== null) {
        setBackgroundImage(videoEl, alreadyLoadedUrl.url, topAndLeftRelative)
      }
      else {
        setBackgroundImage(videoEl, refImage[1].url, topAndLeftRelative)
        loadImageIntoCache({ fileName: fileName, url: refImage[1].url })
      }
    }
    else {
      setBackgroundImage(videoEl, refImage[1].url, topAndLeftRelative)
    }
    // Setting data- property for debugging purposes
    if (refImage[1].id) {
      videoEl.setAttribute("data-reference-image-id", refImage[1].id.toString())
    }
    ctx.clearRect(0, 0, canvasDims.canvasWidth, canvasDims.canvasHeight)
    pose[1].forEach(function (dc) {
      dc.poses.forEach(function (p) {
        if (p.camera === firstPose_1.camera) {
          // console.log(`drawing pose on camera: ${p.camera}`);
          renderPose(__assign(__assign({}, canvasDims), { ctx: ctx, coords: zip(p.x, p.y) }), ratio)
          var pos = allPositions.find(function (pos) { return pos[0] === p.person_position_type_id })
          if (poseIndicator && pos) {
            poseIndicator.innerText = pos[1]
          }
        }
      })
    })
    return
  default:
    expectNever(poseFound)
  }
}
function fixed_line_date_format(d, format = {}) {
  var localeZone = getUserLocaleAndTimeZone()
  return d.toLocaleString(localeZone.locale, { timeZone: localeZone.timeZone, ...format })
}
function renderFixedline(s, els) {
  els.fixedLineText.innerText = fixed_line_date_format(s.selectedTimeAdjusted)
}
function prepareHourline(document) {
  var hourline = document.createElement("div")
  hourline.setAttribute("class", "hourline")
  var hourline_text = document.createElement("label")
  hourline.appendChild(hourline_text)
  return hourline
}
function expectNever(_) {
  throw new Error("Can't happen")
}
function updateState(dispatch, state, a, constants) {
  // console.log(a);
  function bufferDetailsIfNeeded(state) {
    var needsDetailedBufferingRes = needsDetailedBuffering(state)
    if (needsDetailedBufferingRes.tag === "NeedsBuffering") {
      bufferDetailedRange(needsDetailedBufferingRes.data, dispatch)
    }
    var open = needsDetailedBufferingRes.tag === "NeedsBuffering"
      ? state.detailedPoseBufferRequestsOpen.concat([
        needsDetailedBufferingRes.data,
      ])
      : state.detailedPoseBufferRequestsOpen
    return __assign(__assign({}, state), { detailedPoseBufferRequestsOpen: open })
  }
  // We only buffer the rough history in the past for now
  function bufferRoughIfNeeded(state) {
    var needsRoughBufferingRes = needsRoughBufferingHistory(state)
    var newRoughPoseBufferRequestOpen = needsRoughBufferingRes.tag === "DoesntNeedBuffering"
      ? null
      : needsRoughBufferingRes.tag === "AlreadyBuffering"
        ? state.roughPoseBufferRequestOpen
        : needsRoughBufferingRes.tag === "NeedsBuffering"
          ? needsRoughBufferingRes.data
          : expectNever(needsRoughBufferingRes)
    if (needsRoughBufferingRes.tag === "NeedsBuffering") {
      bufferRoughHistory(state.roughPoseBuffer.range, needsRoughBufferingRes.data, dispatch)
    }
    return __assign(__assign({}, state), { roughPoseBufferRequestOpen: newRoughPoseBufferRequestOpen })
  }
  switch (a.tag) {
  case "Tick":
    if (state.paused !== null) {
      return state
    }
    else {
      var newState = __assign(__assign({}, state), { selectedTimeAdjusted: addMilliseconds(state.selectedTimeFixed, a.currentTime.getTime() - state.topTime.getTime()) })
      if (state.scrolling) {
        return newState
      }
      else {
        return bufferDetailsIfNeeded(newState)
      }
    }
  case "BatchRefreshTimeline":
    renderHourlines(constants.timeline, constants.hourline, { currentTime: a.currentTime, earliestTime: state.endTime }, state.roughPoseBuffer.activities)
    if (state.paused !== null) {
      return state
    }
    else {
      var newRoughPoseBufferRequestOpen = state.roughPoseBufferRequestOpen
      if (newRoughPoseBufferRequestOpen === null) {
        bufferNewRough(a.currentTime, state.roughPoseBuffer.range[0], dispatch)
        newRoughPoseBufferRequestOpen = a.currentTime
      }
      return __assign(__assign({}, state), { topTime: a.currentTime, selectedTimeFixed: new Date(state.selectedTimeAdjusted), roughPoseBufferRequestOpen: newRoughPoseBufferRequestOpen })
    }
  case "NewRoughLoaded":
    return __assign(__assign({}, state), { roughPoseBuffer: {
      range: [a.newEnd, state.roughPoseBuffer.range[1]],
      poses: a.poses.concat(state.roughPoseBuffer.poses),
      activities: a.activities.concat(state.roughPoseBuffer.activities)
    }, images: {
      range: [a.newEnd, state.roughPoseBuffer.range[1]],
      images: a.images.concat(state.images.images)
    }, roughPoseBufferRequestOpen: null })
  case "RoughHistoryLoaded":
    var historyLoadedState = __assign(__assign({}, state), { roughPoseBuffer: {
      range: [state.roughPoseBuffer.range[0], a.toBuffer],
      poses: state.roughPoseBuffer.poses.concat(a.poses),
      activities: state.roughPoseBuffer.activities.concat(a.activities)
    }, images: {
      range: [state.images.range[0], a.toBuffer],
      images: state.images.images.concat(a.images)
    }, roughPoseBufferRequestOpen: null })

    renderHourlines(constants.timeline, constants.hourline, { currentTime: a.currentTime, earliestTime: state.endTime }, historyLoadedState.roughPoseBuffer.activities)
    return historyLoadedState
  case "RoughHistoryLoadingFailed":
    return __assign(__assign({}, state), { roughPoseBufferRequestOpen: null })
  case "DetailedRangeLoaded":
    var overlappingBs = state.detailedPoseBuffers.filter(function (b) {
      return overlap(b.range, a.range)
    })
    var newPoses = overlappingBs
      .reduce(function (acc, b) { return acc.concat(b.poses) }, a.poses)
      .sort(function (a, b) { return (a[0] > b[0] ? -1 : 1) }) // sorting by Date desc. Should be fast as most of this should already be sorted
    var rangeEnds = overlappingBs
      .concat({ range: a.range, poses: a.poses })
      .map(function (b) { return b.range[0].getTime() })
    var rangeStarts = overlappingBs
      .concat({ range: a.range, poses: a.poses })
      .map(function (b) { return b.range[1].getTime() })
    var newRange = [
      new Date(Math.min(Math.max.apply(Math, rangeEnds), a.responseRequested.getTime() // Adding responseRequested in the mix here: we often query the API with a range where the end is in the future. You obviously can't say that you already received images from the future, so we bound it on the "current date"; for that we use responseRequested to be a bit conservative and not miss anything
      )),
      new Date(Math.min.apply(Math, rangeStarts)),
    ]
    var newBuffers = state.detailedPoseBuffers
      .filter(function (b) { return !overlap(b.range, a.range) }) // Remove overlapping buffers
      .concat([{ range: newRange, poses: newPoses }]) // Add newly created one
      .sort(function (a, b) {
        // sort DESC
        return a.range[0] > b.range[0] ? -1 : 1
      })

    return __assign(__assign({}, state), { detailedPoseBuffers: newBuffers,
      // removing open request
      detailedPoseBufferRequestsOpen: state.detailedPoseBufferRequestsOpen.filter(function (r) { return !(r[0] === a.range[0] && r[1] === a.range[1]) })
    })
  case "DetailedRangeLoadingFailed":
    return __assign(__assign({}, state), {
      // removing open request
      detailedPoseBufferRequestsOpen: state.detailedPoseBufferRequestsOpen.filter(function (r) { return !(r[0] === a.range[0] && r[1] === a.range[1]) }), detailedPoseBufferRequestsFailed: state.detailedPoseBufferRequestsFailed.concat([a.range[0], a.range[1]]) })
  case "UserScrolledAndWaited":
    return bufferDetailsIfNeeded(__assign(__assign({}, state), { scrolling: false }))
  case "UserScrolled":
    // If we get close to the currently rendered endtime -> we render more hourlines for "infinite" scroll
    var newEndTime = timeDiffInMs(a.date, state.endTime) < 240 * 60 * 1000
      ? addHours(state.endTime, -8)
      : state.endTime
    if (newEndTime !== state.endTime) {
      renderHourlines(constants.timeline, constants.hourline, {
        currentTime: a.currentTime,
        earliestTime: newEndTime
      }, state.roughPoseBuffer.activities)
    }
    return bufferRoughIfNeeded(__assign(__assign({}, state), { endTime: newEndTime, scrolling: true, selectedTimeFixed: a.date, selectedTimeAdjusted: state.paused === null
      ? addMilliseconds(a.date, a.currentTime.getTime() - state.topTime.getTime())
      : addMilliseconds(a.date, state.paused.date.getTime() - state.topTime.getTime()) }))
  case "Pause": {
    var newS = state.paused === null ? { showSource: false, date: a.d } : null
    if (constants.ui) {
      if (newS === null) {
        removeClass(constants.ui.realview.realviewContainer, "paused")
        constants.ui.realview.video.setAttribute("src", "")
      }
      else {
        addClass(constants.ui.realview.realviewContainer, "paused")
      }
    }
    return __assign(__assign({}, state), { paused: newS })
  }
  case "ShowSource": {
    if (state.paused === null) {
      return state
    }
    else {
      getSourceImage(a.poseId).then(function (url) {
        if (constants.ui) {
          constants.ui.realview.video.setAttribute("src", url)
        }
      })
      return __assign(__assign({}, state), { paused: { showSource: true, date: state.paused.date } })
    }
  }
  default:
    expectNever(a)
  }
}
function calcTopOffset(_a) {
  var time = _a.time, initialTime = _a.initialTime
  var msDiff = initialTime.getTime() - time.getTime()
  var minutesDiff = Math.round(msDiff / (60 * 1000))
  return minutesDiff * (hourHeight / 60) + offset
}
function createNewHourline(hourline, _a) {
  var time = _a.time, initialTime = _a.initialTime
  // Kinda dirty, really relying on DOM structure here
  var line = hourline.cloneNode(true)
  line.childNodes[0].innerText = fixed_line_date_format(time, { hour: "2-digit", minute: "2-digit" })
  line.setAttribute("style", "width: 100%; position: absolute; top: " +
        calcTopOffset({ time: time, initialTime: initialTime }) +
        "px")
  return line
}
function createActivityLine(initialTime, a) {
  var container = document.createElement("div")
  container.setAttribute("data-time", a.time.toISOString())
  addClass(container, "activityline")
  container.setAttribute("style", "position: absolute; top: " +
        calcTopOffset({ time: a.time, initialTime: initialTime }) +
        "px")
  var iconC = document.createElement("span")
  addClass(iconC, "fa-stack")
  var icon = document.createElement("i")
  addClass(icon, "fa fa-stack-1x " + a.icon)
  var iconBg = document.createElement("i")
  addClass(iconBg, "fa fa-stack-2x fa-circle")
  iconC.appendChild(icon)
  iconC.appendChild(iconBg)
  var text = document.createElement("label")
  text.innerText = a.desc
  container.appendChild(iconC)
  container.appendChild(text)
  return container
}
function renderHourlines(timeline, hourline, opts, activities) {
  // remove old ones
  for (var i = timeline.childNodes.length; i >= 0; i--) {
    if (timeline.lastChild) {
      timeline.removeChild(timeline.lastChild)
    }
  }
  var time = new Date(opts.currentTime)
  time.setMinutes(0, 0, 0)
  while (time >= opts.earliestTime) {
    var line = createNewHourline(hourline, {
      initialTime: opts.currentTime,
      time: time
    })
    timeline.appendChild(line)
    time = addHours(time, -1)
  }

  renderActivities(timeline, activities, opts.currentTime, opts.earliestTime)
}

function renderActivities(timeline, activities, currentTime, earliestTime) {
  // const activities: Activity[] = [
  //   {
  //     icon: "fa-bed",
  //     desc: "In bed",
  //     time: t1,
  //   },
  //   {
  //     icon: "fa-bed",
  //     desc: "In bed",
  //     time: t2,
  //   },
  // ];
  activities
    .filter(function (activity) { return activity.time >= earliestTime })
    .forEach(function (activity) {
      var el = createActivityLine(currentTime, activity)
      timeline.appendChild(el)
    })
}
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, ms) {
  var timeout
  return function (a) {
    var run = function () {
      timeout = undefined
      func(a)
    }
    clearTimeout(timeout)
    timeout = setTimeout(run, ms)
  }
}
function addClass(e, c) {
  removeClass(e, c)
  e.setAttribute("class", ((e.getAttribute("class") || "") + " " + c).trim())
}
function removeClass(e, c) {
  e.setAttribute("class", (e.getAttribute("class") || "").replace(c, "").trim())
}
function isSortedDesc(arr) {
  for (var i = 0; i <= arr.length; i++) {
    var el1 = arr[i - 1]
    var el2 = arr[i]
    if (!el1 || !el2) {
      // Skip if either element is undefined
      continue
    }
    else {
      if (el1[0] >= el2[0]) {
        // ok
      }
      else {
        return false
      }
    }
  }
  return true
}
function rangeIsSortedDesc(range) {
  return range[0] >= range[1]
}
function assert(cond, mess) {
  if (!cond) {
    console.error(mess)
  }
}
window.initTimeline = function (parent, enableTimeline, ratio) {
  var initialTopTime = new Date()
  var initialEndTime = addHours(initialTopTime, -6)
  var state = {
    topTime: initialTopTime,
    endTime: initialEndTime,
    selectedTimeAdjusted: initialTopTime,
    selectedTimeFixed: initialTopTime,
    roughPoseBuffer: {
      range: [initialTopTime, initialTopTime],
      poses: [],
      activities: []
    },
    detailedPoseBuffers: [],
    images: { range: [initialTopTime, initialTopTime], images: [] },
    roughPoseBufferRequestOpen: null,
    detailedPoseBufferRequestsOpen: [],
    scrolling: false,
    detailedPoseBufferRequestsFailed: [],
    paused: null,
  }
  // draw all static DOM elements inside the parent
  var _a = initDomElements(parent, document, enableTimeline, ratio), timeline = _a.timeline, timelineContainer = _a.timelineContainer, fixedLineText = _a.fixedLineText, ctx = _a.ctx, video = _a.video, canvas = _a.canvas, ui = _a.ui
  // Preparing hourline for cloning
  var hourline = prepareHourline(document)
  var dispatch = function dispatch(a) {
    state = updateState(dispatch, state, a, { timeline: timeline, hourline: hourline, ui: ui })
    assert(isSortedDesc(state.roughPoseBuffer.poses), "roughPoseBuffer.poses not sorted")
    assert(rangeIsSortedDesc(state.roughPoseBuffer.range), "roughPoseBuffer.range not sorted")
    assert(isSortedDesc(state.images.images), "images not sorted")
    assert(rangeIsSortedDesc(state.images.range), "images range not sorted")
    state.detailedPoseBufferRequestsOpen.forEach(function (r, i) {
      assert(rangeIsSortedDesc(r), "detailedPoseBufferRequestsOpen range " + i + " not sorted")
    })
    state.detailedPoseBuffers.forEach(function (pb, i) {
      assert(rangeIsSortedDesc(pb.range), "detailedPoseBuffer " + i + " range not sorted")
      assert(isSortedDesc(pb.poses), "detailedPoseBuffer " + i + " not sorted")
    })
    window.state = state
    rerender(state)
  }
  var rerender = function (state) {
    var _a = canvas.getBoundingClientRect(), width = _a.width, height = _a.height
    renderFixedline(state, { fixedLineText: fixedLineText })
    renderVideo(video, (ui === null || ui === void 0 ? void 0 : ui.poseIndicator) || null, ctx, state, {
      canvasWidth: width,
      canvasHeight: height
    }, ratio)
  }
  function dispatchUserScrolledAndWaitedImpl(d) {
    dispatch({ tag: "UserScrolledAndWaited", date: d })
  }
  var dispatchUserScrolledAndWaited = debounce(dispatchUserScrolledAndWaitedImpl, 500)
  // Add scroll behavior
  timelineContainer.addEventListener("scroll", function onTimelineScroll(e) {
    var scrollTop = e.target.scrollTop
    var diffInSeconds = scrollTop / (hourHeight / (60 * 60))
    var newSelectedTime = addMilliseconds(state.topTime, -diffInSeconds * 1000)
    dispatch({
      tag: "UserScrolled",
      date: newSelectedTime,
      currentTime: new Date()
    })
    dispatchUserScrolledAndWaited(newSelectedTime)
  })
  if (ui !== null) {
    ui.realview.pauseButton.addEventListener("click", function () {
      dispatch({ tag: "Pause", d: new Date() })
    })
    ui.realview.showSourceButton.addEventListener("click", function () {
      var poseFound = findBestPose(state)
      switch (poseFound.tag) {
      case "PoseFound":
        dispatch({ tag: "ShowSource", poseId: poseFound.data[1][0].id })
        break
      default: {
        var caption = poseFound.tag === "PoseServerError"
          ? "Server error"
          : poseFound.tag === "PoseNoData"
            ? "No pose found"
            : poseFound.tag === "PoseLoading"
              ? "Pose still loading"
              : expectNever(poseFound)
        console.error(caption)
        alert(caption)
      }
      }
    })
    ui.realview.nextButton.addEventListener("click", function () {
      var newD = new Date(state.selectedTimeFixed)
      newD.setSeconds(newD.getSeconds() + 2)
      dispatch({
        tag: "UserScrolled",
        date: newD,
        currentTime: new Date()
      })
      dispatchUserScrolledAndWaited(newD)
    })
    ui.realview.prevButton.addEventListener("click", function () {
      var newD = new Date(state.selectedTimeFixed)
      newD.setSeconds(newD.getSeconds() - 2)
      dispatch({
        tag: "UserScrolled",
        date: newD,
        currentTime: new Date()
      })
      dispatchUserScrolledAndWaited(newD)
    })
    var onShowRangeButtons = function (order) {
      var poseFound = findBestPose(state)
      switch (poseFound.tag) {
      case "PoseFound":
        // Removed directing to admin/person_poses/annotator
        break
      default: {
        var caption = poseFound.tag === "PoseServerError"
          ? "Server error"
          : poseFound.tag === "PoseNoData"
            ? "No pose found"
            : poseFound.tag === "PoseLoading"
              ? "Pose still loading"
              : expectNever(poseFound)
        console.error(caption)
        alert(caption)
      }
      }
    }
    ui.realview.showUpTillNowButton.addEventListener("click", function () {
      return onShowRangeButtons("prev")
    })
    ui.realview.showFromNowOnButton.addEventListener("click", function () {
      return onShowRangeButtons("next")
    })
  }
  window.timelineRefreshInterval = setInterval(function () {
    dispatch({ tag: "Tick", currentTime: new Date() })
  }, 1000)
  renderHourlines(timeline, hourline, { currentTime: initialTopTime, earliestTime: initialEndTime }, state.roughPoseBuffer.activities)
  // setInterval(function () {
  //   dispatch({ tag: "BatchRefreshTimeline", currentTime: new Date() });
  // }, 10000);
  dispatch({
    tag: "UserScrolled",
    date: initialTopTime,
    currentTime: initialTopTime
  })
  dispatch({
    tag: "UserScrolledAndWaited",
    date: initialTopTime
  })
  window.dispatch = dispatch
}
//# sourceMappingURL=index.js.map
